import { Model } from '@vuex-orm/core'

const TRADE_STATUS = {
  Invalid: 1,
  Active: 2,
  Accepted: 3,
  Countered: 4,
  Expired: 5,
  Canceled: 6,
  Declined: 7,
  InvalidItems: 8,
  CreatedNeedsConfirmation: 9,
  CanceledBySecondFactor: 10,
  InEscrow: 11,
  Errored: 99,
  Complete: 1000,
  Create: 1001,
  Decline: 1002,
  Confirm: 1003,
  Accept: 1004,
  ReceiveCreate: 1005,
  ReceiveAccept: 1006,
  GameRake: 1007,
}

const TRADE_ERRORS = {
  UnknownError: 9000,
  Busy: 9001,
  Escrow: 9002,
  InvalidAction: 9003,
  InvalidParams: 9004,
  InvalidBotUsername: 9005,
  CannotTrade: 9006,
  InvalidTradeUrl: 9007,
  SteamOffline: 9008,
  UserTradeBan: 9009,
  UserTradeUnavailable: 9010,
  UserPrivacyPrivate: 9011,
}

const STATUS_TEXT = {
  2: 'Active',
  3: 'Accepted',
  4: 'Countered',
  5: 'Expired',
  6: 'Expired',
  7: 'Declined',
  8: 'Error',
  99: 'Error',
  1001: 'Sending...',
}

const ERROR_TEXT = {
  [TRADE_ERRORS.UnknownError]: 'Unknown error, please try again.',
  [TRADE_ERRORS.Busy]: 'Unknown error, please try again.',
  [TRADE_ERRORS.Escrow]: 'You do not have the Steam mobile authenticator active for more than 7 days.',
  [TRADE_ERRORS.InvalidAction]: 'Unknown error, please contact support.',
  [TRADE_ERRORS.InvalidParams]: 'Unknown error, please contact support.',
  [TRADE_ERRORS.InvalidBotUsername]: 'Unknown error, please contact support.',
  [TRADE_ERRORS.CannotTrade]: 'Your Steam account cannot trade.',
  [TRADE_ERRORS.InvalidTradeUrl]: 'Your Trade URL is invalid, please update it.',
  [TRADE_ERRORS.SteamOffline]: 'Steam is offline, please try again later.',
  [TRADE_ERRORS.UserTradeBan]: 'Your Steam account cannot trade.',
  [TRADE_ERRORS.UserTradeUnavailable]: 'Your Steam account cannot trade.',
  [TRADE_ERRORS.UserPrivacyPrivate]: 'Your Steam profile is private, please make it public.',
}

const EMIT_STATUS = {
  Create: 1001,
  ReceiveCreate: 1005,
  ReceiveAccept: 1006,
}

const PENDING_STATES = [
  EMIT_STATUS.Create,
  EMIT_STATUS.ReceiveCreate,
  EMIT_STATUS.ReceiveAccept,
  TRADE_STATUS.Active,
  TRADE_STATUS.CreatedNeedsConfirmation,
  TRADE_STATUS.InEscrow,
]

const RESEND_STATES = [4, 5, 6, 7, 8, 99]

class Trade extends Model {
  static entity = 'trades'

  static fields() {
    return {
      id: this.string(),
      tradeId: this.number(),
      status: this.number(),
      type: this.string(''),
      method: this.string(''),
      items: this.attr([]),
      error: this.string(null).nullable(),
    }
  }

  get statusText() {
    return STATUS_TEXT[this.status]
  }

  get errorText() {
    return ERROR_TEXT[this.error] ?? ERROR_TEXT[TRADE_ERRORS.UnknownError]
  }

  get tradeOfferUrl() {
    return `https://steamcommunity.com/tradeoffer/${this.tradeId}`
  }

  get canResend() {
    if (this.type !== 'withdraw') return false
    return RESEND_STATES.includes(this.status)
  }

  get isActive() {
    return this.status === TRADE_STATUS.Active
  }

  get isSending() {
    return Object.values(EMIT_STATUS).includes(this.status)
  }

  get isPending() {
    if (this.type === 'deposit') {
      return [
        ...Object.values(PENDING_STATES),
        TRADE_STATUS.Active,
      ].includes(this.status)
    }

    return [
      ...Object.values(PENDING_STATES),
      TRADE_STATUS.Active,
      TRADE_STATUS.Declined,
      TRADE_STATUS.Canceled,
      TRADE_STATUS.Expired,
      TRADE_STATUS.Errored,
      TRADE_STATUS.Countered,
      TRADE_STATUS.InvalidItems,
    ].includes(this.status)
  }
}

export default Trade
